export const modes = [
  {
    label: 'All',
    value: 'and_condition'
  },
  {
    label: 'Any',
    value: 'or_condition'
  }
];